// extracted by mini-css-extract-plugin
var _1 = "ControlBarContributorsButton-module__animateUploadProgressBarWidth--IdiY8";
var _2 = "ControlBarContributorsButton-module__animatedBackground--mMMjI";
var _3 = "ControlBarContributorsButton-module__button--zf3ma";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button" }
